var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDonateHeart = function SvgDonateHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d6383a",
    d: "M21.765 5.812C21.765 2.596 19.169 0 15.977 0a5.77 5.77 0 0 0-4.597 2.276A5.77 5.77 0 0 0 6.784 0C3.592 0 .995 2.607.995 5.812c0 1.678.703 3.184 1.83 4.242l6.96 7.234s1.542 1.602 3.138 0l6.98-7.202a5.82 5.82 0 0 0 1.862-4.274"
  })));
};
export default SvgDonateHeart;